import React, { useState } from "react";
import VideoModal from "./VideoModal";
import "../Courses.css";

const Courses = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
    {
      id: 1,
      title: "Introduction to Algebra",
      desc: "Learn the basics of Algebra in this easy-to-understand tutorial! This video covers: What Algebra is and why it’s important. Understanding variables, constants, and expressions. How to write and simplify algebraic expressions. Introduction to equations and simple problem-solving. Perfect for beginners, students, and anyone wanting to build a strong foundation in mathematics. Start your algebra journey today and make learning math fun and easy!",
      url: "https://flippedlearning.neinus.com/videos/Introduction.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/algebra-1-prep.jpg",
    },
    {
      id: 2,
      title: "Arithmetic of Polynomials",
      desc: "Master the arithmetic of polynomials with this easy-to-follow tutorial! In this video, you will learn how to: Add and subtract polynomials by combining like terms. Multiply polynomials using distributive property and special formulas. Divide polynomials using long division and synthetic division. Understand special products like squares and cubes of binomials. This video is perfect for students, teachers, or anyone looking to strengthen their algebra skills. Watch step by step and practice to become confident in solving polynomial problems!",
      url: "https://flippedlearning.neinus.com/videos/Polynomials.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/Polynomials.jpeg",
      },
    {
      id: 3,
      title: "Algebric Identities",
      desc: "Learn key algebraic identities and formulas to simplify expressions, solve equations, and strengthen your foundation in algebra. Perfect for beginners and students looking to master essential algebra concepts.",
      url: "https://flippedlearning.neinus.com/videos/Algebric Identities.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/AI.png",
      },
    {
      id: 4,
      title: "Division of Polynomials",
      desc: "Master the techniques of dividing polynomials using long division and synthetic division. Learn step-by-step methods to simplify expressions and solve polynomial equations with confidence",
      url: "https://flippedlearning.neinus.com/videos/Division of Polynomials.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/DofP.png",
      },
     {
      id: 5,
      title: "Factorisation",
      desc: "Learn the techniques of factorising algebraic expressions to simplify equations and solve problems step by step. Master methods like common factors, grouping, and special products with ease.",
      url: "https://flippedlearning.neinus.com/videos/Factorisation.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/factor.png",
    },
    {
      id: 6,
      title: "Linear Equation",
      desc: "Learn to solve linear equations step by step. Understand how to find unknowns, simplify expressions, and apply methods for one-variable and two-variable equations.",
      url: "https://flippedlearning.neinus.com/videos/Linear Equation.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/LE.png",
      },
    {
      id: 7,
      title: "Reminder Theorem",
      desc: "Understand and apply the Remainder Theorem to find remainders of polynomial division quickly and efficiently. Learn step-by-step techniques with examples for easy mastery.",
      url: "https://flippedlearning.neinus.com/videos/Reminder Theorem.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/RT.jpg",
      },
    {
      id: 8,
      title: "GCD (Greatest Common Divisor)",
      desc: "Learn how to find the greatest common divisor (GCD) of numbers and polynomials. Master step-by-step methods to simplify problems and solve equations efficiently.",
      url: "https://flippedlearning.neinus.com/videos/GCD.mp4",
      thumbnail: "https://flippedlearning.neinus.com/videos/greatest-common-divisor.png",
    },
  ];
 const resourceReferences = [
    {
      id: 101,
      title: "Polynomials",
      url: " https://youtu.be/U-eEdBzyH_k?si=S1MtI-HbOsHG5-WW",
      thumbnail: "https://img.youtube.com/vi/U-eEdBzyH_k/0.jpg",
    },
    {
      id: 102,
      title: "Remainder Theorem",
      url: "https://youtu.be/VQbGQrRjTVw?si=tBEdetvLVuHi2_Rx",
      thumbnail: "https://img.youtube.com/vi/VQbGQrRjTVw/0.jpg",
    },
    {
      id: 103,
      title: "Algebraic Identities",
      url: "https://youtu.be/hgXK6u4qQ_0?si=N_9t1d85JS6oi6bg",
      thumbnail: "https://img.youtube.com/vi/hgXK6u4qQ_0/0.jpg",
    },
    {
      id: 104,
      title: "Factorisation",
      url: "https://youtu.be/VYccGX_drns?si=kTxTVM_vmKQS07Xk",
      thumbnail: "https://img.youtube.com/vi/VYccGX_drns/0.jpg",
    },
    {
      id: 105,
      title: "Division of Polynomials",
      url: "https://youtu.be/MaKh93ATgIE?si=Qz2C18rjB0GBBXqj",
      thumbnail: "https://img.youtube.com/vi/MaKh93ATgIE/0.jpg",
    },
    {
      id: 106,
      title: "GCD",
      url: "https://youtu.be/kfpN9rutIig?si=DafeMulw_mNC2CeT",
      thumbnail: "https://img.youtube.com/vi/kfpN9rutIig/0.jpg",
    },
    {
      id: 107,
      title: "Linear Equations",
      url: "https://youtu.be/hZ6-RHL4lB8?si=DjxLnpddy-AOZaL5",
      thumbnail: "https://img.youtube.com/vi/hZ6-RHL4lB8/0.jpg",
    },
  ];
  return (
    <section className="course-section">
     <h3>Video Tutorials</h3>
          <div className="course-grid">
        {videos.map((video) => (
          <div key={video.id} className="course-card">
            <div className="thumbnail" onClick={() => setSelectedVideo(video)}>
              <img src={video.thumbnail} alt={video.title} />
              <button className="play-btn">▶</button>
            </div>

            <h3>{video.title}</h3>
            <p>{video.desc}</p>
          </div>
        ))}
      </div>
 {/* Resource References Section */}
      <h3 style={{ marginTop: "40px" }}>Reference Tutorials</h3>
      <div className="course-grid">
        {resourceReferences.map((res) => (
          <div key={res.id} className="course-card">
            <div className="thumbnail" onClick={() => setSelectedVideo(res)}>
              <img src={res.thumbnail} alt={res.title} />
              <button className="play-btn">▶</button>
            </div>
            <h3>{res.title}</h3>
          </div>
        ))}
      </div>

      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
    </section>
  );
};

export default Courses;
